<template>
  <div class="h-dialogContainer">
    <form id="noRealTaskResourceReportDialog1">
      <div class="row">
        <div class="col-sm-6">
          <div class="h-col-inputBox-left">
            <div class="h-inputLit">{{$t('Pm.timeRange')}}</div>
            <ejs-radiobutton :label='$t("Pm.today")' name="timeRange" :checked="true" value="0" :change="changeOfTimeRange"></ejs-radiobutton>
            <ejs-radiobutton :label='$t("Pm.yesterday")' name="timeRange" value="1" :change="changeOfTimeRange"></ejs-radiobutton>
            <ejs-radiobutton :label='$t("Pm.currentWeek")' name="timeRange" value="2" :change="changeOfTimeRange"></ejs-radiobutton>
            <ejs-radiobutton :label='$t("Pm.lastWeek")' name="timeRange" value="3" :change="changeOfTimeRange"></ejs-radiobutton>
            <ejs-radiobutton :label='$t("Pm.specified")' name="timeRange" value="4" :change="changeOfTimeRange"></ejs-radiobutton>
          </div>
          <div class="h-col-inputBox-left">
            <div class="h-inputLit">{{$t('Pm.start_time')}}</div>
            <ejs-datetimepicker :locale='locale' :change='validateOfNoRealResourceReport' :format='dateFormat' name="startTimeForResource" :enabled='startTimeEnabled' v-model='startTimeForResource'></ejs-datetimepicker>
          </div>
          <div class="h-col-inputBox-left">
            <div class="h-inputLit">{{$t('Pm.end_time')}}</div>
            <ejs-datetimepicker :locale='locale' :change='validateOfNoRealResourceReport' :format='dateFormat' name="endTimeForResource" :enabled='endTimeEnabled' v-model='endTimeForResource'></ejs-datetimepicker>
          </div>
          <div class="h-col-inputBox-left">
            <div class="h-inputLit">{{$t('Pm.measureCycle')}}</div>
            <ejs-dropdownlist :dataSource="dataSourceOfSampleTime" :fields="filedsOfSampleTime" v-model="sampleTimeOfResourceReport"></ejs-dropdownlist>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="h-inputLit">{{$t('Pm.resourceList')}}</div>
          <div class="h-borderBox height-260">
            <div class="h-borderTree-pm-content">
              <div class="col-lg-12 control-section">
                <div class="tree-control-wrapper">
                  <ejs-treeview ref='neTreeForNoRealTaskResourceReport'
                                id='neTreeForNoRealTaskResourceReport'
                                :fields='fieldsOfNeTreeForNoRealTaskResourceReport'
                                :showCheckBox='true'
                                :nodeChecked="nodeCheckedOfNoRealTaskResourceTree"
                  ></ejs-treeview>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import DateUtil from "../../../../util/DateUtil";
  import {FormValidator} from "@syncfusion/ej2-vue-inputs";
  import CommonUtil from "../../../../util/CommonUtil";

  export default {
    name: 'NoRealTaskResourceReportDialog1',
    props:[
      'selectNeType'
    ],
    data() {
      return {
        startTimeEnabled: false,
        endTimeEnabled: false,
        locale: localStorage.getItem('locale'),
        startTimeForResource: new Date(`${DateUtil.getTodayYearMonthDay()} 00:00:00`),
        endTimeForResource: new Date(`${DateUtil.getTodayYearMonthDay()} 23:59:59`),
        dateFormat: 'yyyy-MM-dd HH:mm:ss',
        formObjOfNoRealResourceReport: '',
        optionsOfNoRealResourceReportDialogValidation: {
          customPlacement(inputElement, errorElement) {
            errorElement.style.position = 'fixed';
            inputElement.parentElement.parentElement.appendChild(errorElement);
          },
          rules: {
            startTimeForResource: {
              required: [true, this.$t('Pm.begTimeNull')],
              regex: [/^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/, this.$t('Pm.begTimeFormatError')]
            },
            endTimeForResource: {
              required: [true, this.$t('Pm.endTimeNull')],
              regex: [/^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/, this.$t('Pm.endTimeFormatError')]
            }
          }
        },
        dataSourceOfSampleTime: [{
          cycle: `5${this.$t('Pm.minutes')}`, value: 300000},
          {cycle: `15${this.$t('Pm.minutes')}`, value: 900000},
          {cycle: `30${this.$t('Pm.minutes')}`, value: 1800000},
          {cycle: `60${this.$t('Pm.minutes')}`, value: 3600000},
          {cycle: `24${this.$t('Pm.hours')}`, value: 86400000},
        ],
        filedsOfSampleTime: {
          text: 'cycle',
          value: 'value'
        },
        sampleTimeOfResourceReport: 900000,
        fieldsOfNeTreeForNoRealTaskResourceReport: {
          dataSource: [{ children: [] }],
          id: 'id',
          text: 'text',
          child: 'children',
          expanded: 'state',
          iconCss: 'iconCls'
        },
        nodeCheckIdListForResourceReport: [],
        nodeCheckInfoListForResourceReport: {}

      }
    },
    methods: {
      changeOfTimeRange(args) {
        switch (args.value) {
          case '0':
            this.startTimeForResource = new Date(`${DateUtil.getTodayYearMonthDay()} 00:00:00`);
            this.endTimeForResource = new Date(`${DateUtil.getTodayYearMonthDay()} 23:59:59`);
            this.startTimeEnabled = false;
            this.endTimeEnabled = false;
            break;
          case '1':
            this.startTimeForResource = new Date(`${DateUtil.getYesterdayYearMonthDay()} 00:00:00`);
            this.endTimeForResource = new Date(`${DateUtil.getYesterdayYearMonthDay()} 23:59:59`);
            this.startTimeEnabled = false;
            this.endTimeEnabled = false;
            break;
          case '2':
            this.startTimeForResource = new Date(`${DateUtil.getCurrentWeekBeginYearMonthDay()} 00:00:00`);
            this.endTimeForResource = new Date(`${DateUtil.getCurrentWeekEndYearMonthDay()} 23:59:59`);
            this.startTimeEnabled = false;
            this.endTimeEnabled = false;
            break;
          case '3':
            this.startTimeForResource = new Date(`${DateUtil.getLastWeekBeginYearMonthDay()} 00:00:00`);
            this.endTimeForResource = new Date(`${DateUtil.getLastWeekEndYearMonthDay()} 23:59:59`);
            this.startTimeEnabled = false;
            this.endTimeEnabled = false;
            break;
          case '4':
            this.startTimeForResource = '';
            this.endTimeForResource = '';
            this.startTimeEnabled = true;
            this.endTimeEnabled = true;
            break;
          default:
            break;
        }
      },
      validateOfNoRealResourceReport() {
        const formStatus = this.formObjOfNoRealResourceReport.validate();
        if (!formStatus) {
          return false;
        }
        return true;
      },
      bindValidateOfResourceReport() {
        this.formObjOfNoRealResourceReport = new FormValidator('#noRealTaskResourceReportDialog1', this.optionsOfNoRealResourceReportDialogValidation);
      },
      getNoRealTaskResourceTree() {

        const params = {
          neTypeCode: this.selectNeType,
          sampleTime: this.sampleTimeOfResourceReport
        }
        this.$axios.post(`/lte/ems/pm/noReal/report/buildNoRealTaskResourceTreeForReport.html${CommonUtil.analyticParameter(params)}`).then((response) => {
          this.fieldsOfNeTreeForNoRealTaskResourceReport = {
            dataSource: response.data,
            id: 'id',
            text: 'text',
            child: 'children',
            expanded: 'state',
            iconCss: 'iconCls'
          };
        });
      },
      nodeCheckedOfNoRealTaskResourceTree(args){
        console.log(args)

        let checkedNodeInfoList = args.data.filter(function (checkedNode) {
          return checkedNode.hasChildren == false;
        }).map(function (checkedNode) {
          return checkedNode;
        });

        let checkedNodeIds = checkedNodeInfoList.map(function(checkedNode){
          return checkedNode.id;
        })


        // 获取点击状态 check/uncheck
        const checkStatus = args.action;

        // 如果状态为点击，将点击的节点添加到点击节点列表中
        if(checkStatus == "check"){
          for(let checkedNode of checkedNodeInfoList){
            this.nodeCheckIdListForResourceReport.push(checkedNode.id);
            this.nodeCheckInfoListForResourceReport[checkedNode.id] = checkedNode;
          }
          // 如果状态为取消点击，从点击节点列表中删除对应元素
        }else if(checkStatus == 'uncheck' ){
          this.nodeCheckIdListForResourceReport = this.nodeCheckIdListForResourceReport.filter(function(nodeCheckedId){
            return checkedNodeIds.indexOf(nodeCheckedId) == -1;
          });
          for(let checkedNodeId of checkedNodeIds){
            delete this.nodeCheckInfoListForResourceReport[checkedNodeId];
          }
        }
      }
    },
    mounted() {
      this.bindValidateOfResourceReport();
    }
  }
</script>

<style scoped>
  .h-dialogContainer .h-col-inputBox-left {
    margin-bottom: 18px;
    padding-left: 35px;
    padding-right: 10px;
  }

  .h-dialogContainer .h-col-inputBox-middle {
    margin-top: 25px;
    margin-bottom: 5px;
  }

  .h-dialogContainer .h-col-inputBox-right {
    margin-bottom: 18px;
    padding-left: 10px;
    padding-right: 35px;
  }

  .h-dialogContainer >>> .e-listview .e-list-item.e-active{
    background-color: #007bff;
    color: #fff;
  }
</style>
